import { PremiumPreviewSource } from '../../store/schema/PremiumPreviewData';
import { logUsage } from 'owa-analytics';
import { assertNever } from 'owa-assert';

// Trigger Premium preview from Contextual card, opens PP dialog in middle of screen
export const DP_OPEN_PREMIUM_PREVIEW_FROM_CONTEXTUAL_CARD =
    'EditorProofing_ContextualCardOpenPremiumPreviewOptInDialog ';

// Trigger Premium preview from Settings
export const DP_TRY_NOW_FROM_SETTINGS = 'EditorProofing_SettingsOpenPremiumPreviewOptInDialog ';

// Clicking 'try it now' withing the premium preview, source: Skittle
export const DP_TRY_NOW_PREMIUM_PREVIEW_FROM_SKITTLE_SOURCE =
    'EditorProofing_PremiumPreview_Try_Skittle';

// Clicking 'try it now' withing the premium preview, source: CC_card
export const DP_TRY_NOW_PREMIUM_PREVIEW_FROM_CC_SOURCE = 'EditorProofing_PremiumPreview_Try_CCard';

//  Clicking 'try it now' withing the premium preview, source: Settings
export const DP_TRY_NOW_PREMIUM_PREVIEW_FROM__SETTINGS_SOURCE =
    'EditorProofing_PremiumPreview_Try_Settings';

export function logTryItNowButtonClicked(
    premiumPreviewSource: PremiumPreviewSource,
    hasPremiumPreviewRenderedAfterClickTryNow: boolean
) {
    let dataPointName: string;
    if (hasPremiumPreviewRenderedAfterClickTryNow) {
        dataPointName = getDataPointNameForTriggerPremiumPreview(premiumPreviewSource);
    } else {
        dataPointName = getDataPointNameForTryItNow(premiumPreviewSource);
    }

    dataPointName && logUsage(dataPointName, {}, { isCore: true });
}

/**
 * When user click 'try it now' withing the premium preview
 * this is acutally triggered suggestions
 */
function getDataPointNameForTryItNow(premiumPreviewSource: PremiumPreviewSource) {
    switch (premiumPreviewSource) {
        case 'skittle':
            return DP_TRY_NOW_PREMIUM_PREVIEW_FROM_SKITTLE_SOURCE;
        case 'contextualCard':
            return DP_TRY_NOW_PREMIUM_PREVIEW_FROM_CC_SOURCE;
        case 'settings':
            return DP_TRY_NOW_PREMIUM_PREVIEW_FROM__SETTINGS_SOURCE;
        case 'none':
            return '';
        default:
            assertNever(premiumPreviewSource);
    }
}

/**
 * When user click 'try it now' outside the premium preview dialog
 * Just to triggered the premium preview dialog
 */

function getDataPointNameForTriggerPremiumPreview(premiumPreviewSource: PremiumPreviewSource) {
    switch (premiumPreviewSource) {
        case 'contextualCard':
            return DP_OPEN_PREMIUM_PREVIEW_FROM_CONTEXTUAL_CARD;
        case 'settings':
            return DP_TRY_NOW_FROM_SETTINGS;
        case 'skittle':

        case 'none':
            return '';
        default:
            assertNever(premiumPreviewSource);
    }
}
